import(/* webpackMode: "eager" */ "/app/app/dashboard/v2/page.tsx");
